import { DetailsSideItemProps } from "./types";
import { classes } from "./utils";

export const DetailsSideItem = ({ label, value }: DetailsSideItemProps) => {
  return (
    <div>
      <div className={classes.label}>{label}</div>
      <div className={classes.value}>{value}</div>
    </div>
  );
};
